/**
 * Website vs. document input-type classification for audits.
 *
 * There is no dedicated database column for this: `sourceUrl` is already a
 * reliable discriminator (set only by URL-scan ingestion; null for file
 * uploads and pasted text), so the type is derived rather than stored twice.
 * Centralized here so backend projections and any frontend code that needs
 * the value use the exact same rule.
 */

export type AuditInputType = "document" | "website";

export function getAuditInputType(
  audit: { sourceUrl?: string | null },
): AuditInputType {
  return audit.sourceUrl ? "website" : "document";
}
